(function () {
  'use strict';

  // sorry for that f.. name, but seed and culture are allready in use
  angular.module('cfn').directive('cfnBookingFruit', cfnBookingFruit);

  cfnBookingFruit.$inject = [
    '$q',
    '$rootScope',
    'analyseService',
    'CfnDialogService',
    'i18nFilter',
    'bookingRules',
    'bookingService',
    'search.service',
    'harvestBookingService',
    'fieldSearchService',
    'cultureSearch.service',
    '$timeout'
  ];

  function cfnBookingFruit(
    $q,
    $rootScope,
    analyseService,
    CfnDialogService,
    i18nFilter,
    bookingRules,
    bookingService,
    searchService,
    harvestBookingService,
    fieldSearchService,
    cultureSearchService,
    $timeout
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./fruitTable.html'),
      controller: ['$scope', function ($scope) {

        let isNewBooking = $scope.details.id ? false : true;
        $scope.cropOnlySelectableByUser = false;
        $scope.cropOfOperation = null;

        // Load data from common booking state object into local format
        bookingRules.elements.fruit.onLoad = function (result) {

          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          //
          //  Check Product for Crop first
          //
          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          let loadedCropOfOperation = {};
          let sysCultureId;
          let sowingType = 'MAIN_CROP'
          // Don't show culture selection, even if backend provides no row
          if (result.products.length > 0) {
            //only one product is being supported at this time
            $scope.details.product = angular.copy(result.products[0]);
            // result.productProportions -> $scope.details.productProportions
            $scope.details.productProportions = angular.copy(
                result.productProportions
            );

            if ($scope.details.product.sowingType == 'PERMANENT_CROP') {
              sowingType = 'PERMANENT_CROP';
            }

            if ($scope.details.product && $scope.details.product.harvestProduct && $scope.details.product.harvestProduct.sysCultureId) {
              sysCultureId = $scope.details.product.harvestProduct.sysCultureId;
            }

          } else {

            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            //
            //  Check Crop from Supplies second
            //
            //  BE AWARE: Intialization happens within cfnBookingSupply.onLoad()
            //
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!


            angular.forEach(result.supplies, function (value) {
              // Unmapped supplies might have no type / a type of null

              if (value.indication && value.indication.sysCultureDTO) {
                sysCultureId = value.indication.sysCultureDTO.id;
              }

            });

          }

          if (sysCultureId) {
            cultureSearchService.getSysCulture(sysCultureId).then(
                (response) => {
                  if (response.data) {
                    loadedCropOfOperation.sysCultureDTO = response.data.sysCulture;
                    loadedCropOfOperation.harvestTypes = response.data.sysCulture_harvestTypes;
                    loadedCropOfOperation.harvestTypeOptions = loadedCropOfOperation.harvestType_options = response.data.sysCulture_harvestTypes.map(function (type) {
                      return type.type;
                    });

                    if ($scope.details.product){
                      loadedCropOfOperation.sowingType = sowingType;
                      loadedCropOfOperation.harvestType = $scope.details.product.harvestType;
                      loadedCropOfOperation.harvestUnit = $scope.details.product.unit;
                    }

                  } else {
                    loadedCropOfOperation.sysCultureDTO = null;
                    loadedCropOfOperation.harvestTypes = [];
                  }
                  loadedCropOfOperation.source = 'init';
                  $scope.cropOfOperation = loadedCropOfOperation;
                }
            ).catch(function () {
            });
          }
        };

        $scope.cultureChangePopup = {
          show: false,
          headline: i18nFilter('fe.booking.differentCultures.popup.headline'),
          subheadline: 'fe.common.notice',
          opacity: 1,
          content: 'fe.booking.differentCultures.popup',
          closeText: 'fe.frkr.popup.button.abort',
          okText: 'enums.YesNoEnum.YES',
          helpActionText: 'fe.frkr.popup.button.help'
        };

        $scope.cultureChanged = function (cultureInfo){
          // broadcast if selected culture is changed
          $rootScope.$broadcast('bookingmask-culture-changed', cultureInfo);
        };

        // New Field? or date changed?
        // crop on fields which might be a candidate for cropOfOperation
        $scope.$on('bookingmask-crop-on-fields-changed', (event, args) => {
            if (!$scope.cropOnlySelectableByUser) {
              $scope.cropOfOperation = args; // check  -> $scope.$watch('cropOfOperation'
            }
        });

        $scope.activateSelection = false;
        $scope.toggleActivateSelection = function () {
          $scope.activateSelection = !$scope.activateSelection;
          $scope.cropOnlySelectableByUser = false;
          $scope.removeCultureSelection();
        };

        $scope.removeCultureSelection = function () {
          // -> see $scope.$watch('cropOnFields.sysCultureDTO'
          // $scope.cropOnFields.sysCultureDTO = null;
          $scope.cropOfOperation = null;
          $scope.harvestTypeSelect = [];
          // $scope.cultureChanged(null);
        };

        // --> see  $scope.$on('bookingmask-crop-on-fields-changed', (event, args) => {

        /*$scope.$watch('cropOnFields', function (
            newValue,
            oldValue
        ) {
          if (newValue !== oldValue &&  !$scope.cropOnlySelectableByUser) {
            // $scope.cropOfOperation = newValue; // check  -> $scope.$watch('cropOfOperation'
            // console.log('GOT CROP FROM FIELD SECTION : ', newValue);
          }
        });*/

        $scope.$watch('cropOfOperation', function (
            newValue,
            oldValue
        ) {
          if (newValue !== oldValue) {
            let eventInfo = {
              cropOfOperation: newValue,
              modifiable: !$scope.cropOnlySelectableByUser
            };

            $scope.cultureChanged(eventInfo);

            $timeout(() => {
              $scope.details.fieldList.trigger = ($scope.details.fieldList.trigger) ? !$scope.details.fieldList.trigger : false;
            }, 300);
          }
        });

        /**
         *
         * @param selectedCulture
         */
        $scope.doubleCheckCultureSelection = async function(selectedCulture) {
          // get selected culture
          $scope.changedCulture = selectedCulture;
          let fieldsCrop = {};
          // double check with cultures of field list
          $scope.details.fieldList.forEach((field) => {
            if (field.cropOnField.sysCultureDTO &&
                field.cropOnField.sysCultureDTO.name.toLowerCase() !== selectedCulture.name.toLowerCase()) {
              // if they are not the same popup with not if want to change or not
              $scope.cultureChangePopup.show = true;
              return;
            }
          });

          if(!$scope.cultureChangePopup.show){
            fieldsCrop = await $scope.searchSelected($scope.changedCulture);
            $scope.cropOnlySelectableByUser = true;
            $scope.cropOfOperation = fieldsCrop;
            $scope.$digest();
          }
          return;
        };

        $scope.updateCropOfOperation = async function(selectedItem){
          $scope.cropOnlySelectableByUser = true;
          let fieldsCrop = await $scope.searchSelected(selectedItem);
          $scope.cropOfOperation = fieldsCrop;
          $scope.$digest();
          return;
        };

        $scope.changeCultureOkAction = async function(){
          if ($scope.changedCulture) {
            $scope.cropOnlySelectableByUser = true;
            let fieldsCrop = await $scope.searchSelected($scope.changedCulture);
            $scope.cropOfOperation = fieldsCrop;
            $scope.cultureChangePopup.show = false;
            return;
          }
        };

        $scope.changeCultureAbortAction = function(){
          $scope.activateSelection = false;
          $scope.cultureChangePopup.show = false;
          return;
        };

        /**
         * autocomplete search method
         * @param item
         */
        $scope.search = cultureSearchService.getAllCultures;

        /**
         * autocomplete search method for selected item from list
         * @param item
         */
        $scope.searchSelected = async (selectedItem) => {
          $scope.activateSelection = false;

           let cropCandidate = {};
           cropCandidate.sysCultureDTO = (typeof selectedItem === 'undefined' || selectedItem === null) ?
              {} : selectedItem;

           const response = await cultureSearchService.getSysCulture(selectedItem.id);
              if (response.data) {
                // override with data from service reponse
                cropCandidate.harvestTypes = response.data.sysCulture_harvestTypes;
                cropCandidate.harvestTypeOptions =
                  response.data.sysCulture_harvestTypes.map(function (type) {
                    return type.type;
                  });

                cropCandidate.sysCultureDTO = response.data.sysCulture;
                cropCandidate.harvestUnit = selectedItem.harvestUnit;
                cropCandidate.sowingType = selectedItem.sowingType;
                $scope.cropOnlySelectableByUser = true;

              } else {

                //FIXME is this realy correct or shall we use the intial setup block below instead?
                cropCandidate.sysCultureDTO = null;
                cropCandidate.harvestTypes = [];
              }

           //   $scope.details.product.unit = selectedItem.harvestUnit;
           //   $scope.details.product.sowingType = selectedItem.sowingType;

         return cropCandidate;
          // FIXME WHAT IS IT GOOD FOR?
          // initial setup with given selectedItem
        /*  $scope.cropOnFields.sysCultureDTO = selectedItem;
          $scope.cropOnFields.harvestTypeOptions = $scope.cropOnFields.harvestType_options = selectedItem.harvestTypes;
          $scope.harvestType_options = selectedItem.harvestTypes;
          $scope.details.product.unit = selectedItem.harvestUnit;
          $scope.details.product.sowingType = selectedItem.sowingType;
          */
        };
      }]
    };
  }
})();
